import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SidenavService } from '../../../../shared/services/sidenav.service';
import { ApplistService } from '../../../../shared/services/applist.service';
import { TcmUtilsService } from '../../../../shared/services/tcmUtils.service';
import { HttpClient } from '@angular/common/http';
import { ListRange } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { AppViewService } from '../../../../shared/services/tcm-hub-appview.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgModel } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { read, utils } from 'xlsx';
import { environment } from '../../../../../environments/environment';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
@Component({
    selector: 'app-create-group',
    templateUrl: './create-group.component.html',
    styleUrls: ['./create-group.component.scss'],
    providers: [NgModel],
    standalone: false
})
export class CreateGroupComponent implements OnInit {
  loading = false;
  groupName: any = '';
  SelectedGroupType: any;
  SelectedLob: any;
  FSLO: string = '';
  FAVC: string = '';
  Description: any = '';
  selectAll: boolean = false;
  selectallaskid: boolean = false;
  selectedApplicationName: any = [];
  selectTypeList: any = ['LOB', 'SLO Owner', 'Technical Owner', 'Bulk Upload'];
  groupTypeList: any = ['Custom', 'Platform'];
  groupType: any = 'Custom';
  selectBy: any = 'LOB';
  LOB: any;
  cioList: any = [];
  disabled: boolean;
  details: any;
  catogeryList: { name: any }[];
  lifeCycleStatus: any;
  lobList: any = [];
  lobLists: any = [];
  LobSelected: any;
  sloOwner: any = [];
  tecOwner: any = [];
  techOwnerCache: any = [];
  sloOwnerCache: any = [];
  multiAppSelectAll: boolean = false;
  limitExhaust: boolean = false;
  limitExhaustDes: boolean = false;
  selectedsloOwner: string;
  selctedTecOwner: string;
  multiSelect: boolean = false;
  appliationSelectedLob: any = [];
  multiSelectAttr: string = '""';
  appList = [];
  selectedGlobalAppCode = [];
  initialRange: ListRange = { start: 0, end: 8 };
  selectedFilter: any = [];
  public globalAskids = [];
  public appids = [];
  public searchStatus: any = false;
  public globalAppList = [];
  selectedTmdbCode: string;
  sortedapplist: any = [];
  detailsCache: any = [];
  askList: any = [];
  askGlobalIdList: any = [];
  private: any = 'checked';
  public: any;
  visibility: any = 'Private';
  editid: any;
  SelectedCIO: any = [];
  selectedCatagory: any = [];
  selectedLifecycle: any = [];
  categoryselectall: boolean = false;
  lifecycleselectall: boolean = false;
  lobselectAll: boolean = false;
  CIO: string = '';
  applicationWithLob: any = [];
  applicationWithSloOwner: any = [];
  applicationWithTechOwner: any = [];
  applicationListConst: any[];
  allAppList: any;
  Fowner: any;
  applicationSelectd: any = [];
  @ViewChild('privateRadio') privateRadio: ElementRef;
  @ViewChild('publicRadio') publicRadio: ElementRef;
  isAdminRole: any = false;
  Filepath: string = '';
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  fileToUpload: File = null;
  submitdisable = true;
  showLoader: boolean = false;
  filteredCioList: any = [];
  filteredSubLobList: any = [];
  filteredAppNameList: any = [];
  isFormSubmitted: boolean = false;


  constructor(
    private sidenavService: SidenavService,
    private applistService: ApplistService,
    private tcmUtilService: TcmUtilsService,
    public datepipe: DatePipe,
    private AppViewService: AppViewService,
    public toaster: ToastrService,
    private route: Router,
    private container: ElementRef,
    public dialog: MatDialog,
    private ngmodel: NgModel,
    private sharedAuthService: SharedAuthService,
  ) {}

  ngOnInit() {
    this.disabled = false;
    this.sidenavService.getLobSubLobList().subscribe(data => {
      data = data.sort((a, b) => (a.name < b.name ? -1 : 1));
      data.forEach(element => {
        element.subLob.sort((a, b) => (a.sub_lob < b.sub_lob ? -1 : 1));
      });
      this.details = data;
      this.cioList = data.map(x => {
        return {
          name: x.lob,
          lob_id: x.lob_id,
          subLobnames: x.subLob.map(t => {
            return { subLob_id: t.SubLobID, subLob_name: t.sub_lob };
          })
        };
      });
    });
    this.getAppList();
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.checkAccess();
      });
    } else {
       this.checkAccess();
    }
    this.Filepath = 'assets/Group_Maintanence_BulkUpload.xlsx';
    this.multiAppSelectAll = true;
  }
  checkAccess() {
    const isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    const userData =  this.sharedAuthService.getTechAccessData();
    if (userData && userData.Role.toLowerCase() == 'admin' && isAdminRole) {
      this.isAdminRole = true;
      this.groupType = 'Platform';
    }
  }

  navigateToGroupList() {
    this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
  }

  getAppList() {
    this.showLoader = true;
    this.applistService.getAllApplications().subscribe((data: any[]) => {
      this.details = data;
      this.details = this.removeDup(this.details).sort(this.tcmUtilService.sortOnProperty('LONG_APP_NAME'));
      this.applicationListConst = this.details;
      this.detailsCache = this.details;
      this.applicationListConst = this.details;
      this.appList = this.applicationListConst.slice(0, 500);
      this.allAppList = this.applicationListConst;
      this.askList = this.appList;
      this.sortedapplist = this.details.sort(this.tcmUtilService.sortOnProperty('LONG_APP_NAME'));
      for (let count = 0; count < this.appList.length; count++) {
        this.askGlobalIdList.push(this.appList[count].ASK_GLOBAL_ID);
      }
      this.showLoader = false;
    });
    this.applistService.getAllSlo().subscribe((data: any[]) => {
      this.sloOwnerCache = data.sort(this.tcmUtilService.sortOnProperty('name'));
      this.sloOwner = this.sloOwnerCache.slice(0, 500);
    });
    this.applistService.getAllTechOwners().subscribe((data: any[]) => {
      this.techOwnerCache = data.sort(this.tcmUtilService.sortOnProperty('name'));
      this.tecOwner = this.techOwnerCache.slice(0, 500);
    });
  }

  saveBulkGroup(loggedusermail) {
    const fileType = this.fileToUpload.type;
    const fileExtension = this.fileToUpload.name.split('.').pop();
    if (
      !fileType ||
      !['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(
        fileType
      ) ||
      !['xls', 'xlsx', 'xlsm', 'xlsb'].includes(fileExtension)
    ) {
      this.toaster.error('File format is not supported, Please try with excel files only.');
      return false;
    }
    if (this.groupType === 'Custom') {
      this.visibility = 'Private';
    } else {
      this.visibility = this.visibility ? this.visibility : this.private;
    }
    const data = {
      visibility: this.visibility,
      groupname: this.groupName.trim(),
      Group_Type: this.groupType,
      author: loggedusermail,
      Group_Description: this.Description
    };
    const formData: FormData = new FormData();
    formData.append('group_data', JSON.stringify(data));
    formData.append('cmi_file', this.fileToUpload, this.fileToUpload.name);
    formData.append('User_msid', this.sharedAuthService.getMsid());
    formData.append('User_email', sessionStorage.getItem('loggedInUserEmail'));
    // formData.append('Action_Type', this.uploadType);
    const ServicePromise = this.AppViewService.addBulkGroup(formData);
    ServicePromise.then(res => {
      if (res['Status'] != undefined && res['message'] != 'data inserted successfully') {
        this.toaster.error(res['Status'], '', { timeOut: 10000, positionClass: 'toast-top-center' });
      } else {
        this.toaster.success('Group created successfully. Details are sent to the Email', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
        this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
      }
    }).catch(err => {
      console.log(err);
      this.toaster.error(err.error.message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
    });
  }

  saveGroup(loggedusermail) {
    if (this.groupType === 'Custom') {
      this.visibility = 'Private';
    } else {
      this.visibility = this.visibility ? this.visibility : this.private;
    }
    if (this.groupName && this.selectedApplicationName && this.selectedApplicationName.length > 0) {
      const data = {
        GLOBAL_APP_ID: this.selectedGlobalAppCode,
        visibility: this.visibility,
        groupname: this.groupName,
        Group_Type: this.groupType,
        created_at: this.datepipe.transform(Date(), 'dd MMM yy hh:mma'),
        author: loggedusermail,
        Group_Description: this.Description
      };
      const ServicePromise = this.AppViewService.addgroup(JSON.stringify(data));
      ServicePromise.then(res => {
        if (res) {
          this.toaster.success('Request submitted successfully.', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
          this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
        }
      }).catch(err => {
        this.toaster.error(err.statusText, '', { timeOut: 10000, positionClass: 'toast-top-center' });
        console.log(err);
      });
    } else {
      this.toaster.error('please fill the required details!', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  submitgroup() {
    this.isFormSubmitted = true;
    if (this.groupName.length > 60 || this.Description.length > 300) {
      this.toaster.error("App Group Name or Description characters are more than limit!");
      return;
    }
    if (this.groupName.length == 60) {
      this.limitExhaust = false;
    }
    if (this.Description.length == 300) {
      this.limitExhaustDes = false;
    }
    if (
      this.groupName === '' ||
      this.groupName === undefined ||
      this.Description === '' ||
      this.Description === undefined
    ) {
      this.toaster.error('App Group Name or Description not provided!', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
      return;
    } else {
      if (this.selectBy == 'Bulk Upload' && this.fileToUpload == null) {
        this.toaster.error('Please select file to upload', '',{ timeOut: 10000, positionClass: 'toast-top-center' }) ;
      } else this.submitdisable = false;
      const loggedusermail =
        JSON.parse(sessionStorage.getItem('loggedInUserEmail')) ||
        JSON.parse(sessionStorage.getItem('loggedInUserEmail'));
      if (!loggedusermail) {
        return;
      }
      const data = {
        check_group: this.groupName
      };
      this.AppViewService.getgroup(JSON.stringify(data)).subscribe((res: any) => {
        if (res.length > 0) {
          this.toaster.error('This group name already exists', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
        } else {
          if (this.selectBy == 'Bulk Upload') {
            let arrayBuffer;
            let exceljsondata;
            const fileReader = new FileReader();
            fileReader.onload = () => {
              arrayBuffer = fileReader.result;
              const data = new Uint8Array(arrayBuffer);
              const arr = [];
              for (let i = 0; i < data.length; ++i) arr[i] = String.fromCharCode(data[i]);
              const bstr = arr.join('');
              const workbook = read(bstr, { type: 'binary' });
              const first_sheet_name = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[first_sheet_name];
              exceljsondata = utils.sheet_to_json(worksheet, {
                raw: true,
                defval: ''
              });
              if (worksheet.A1.v !== 'Application_ID') {
                this.toaster.error('Invalid excel format', '', { timeOut: 10000, positionClass: 'toast-top-center' });
              } else if (exceljsondata.length === 0) {
                this.toaster.error('No applications found in excel. Minimum 1 application is required.');
              } else {
                const subTitliMsg =
                  exceljsondata.length + ' Applications selected to be added. Please click on continue to proceed.';
                subTitliMsg.replace('\n/g', '<br/>');
                const dialogConfig = new MatDialogConfig();
                dialogConfig.width = '400px';
                dialogConfig.hasBackdrop = true;
                dialogConfig.minHeight = '200px';
                dialogConfig.height = 'auto';
                dialogConfig.autoFocus = false;
                dialogConfig.data = {
                  title: 'Update Confirmation!',
                  subTitle: subTitliMsg,
                  buttonName: 'Continue'
                };

                const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(result => {
                  if (result.data === 'save') {
                    this.saveBulkGroup(loggedusermail);
                  }
                });
              }
            };
            if(this.fileToUpload !=null) {
              fileReader.readAsArrayBuffer(this.fileToUpload);
            }
          } else this.saveGroup(loggedusermail);
        }
      });
    }
  }

  onItemChange(value) {
    this.visibility = value;
  }

  onGroupTypeChanged(event) {
    this.visibilityOnGroupTypeChange(event.value);
    this.groupType = event.value;
  }
  visibilityOnGroupTypeChange(event) {
    if (event === 'Custom') {
      this.visibility = 'Private';
      return true;
    } else {
      return false;
    }
  }
  onSelectByChanged(event) {
    this.selectBy = event.value;
    this.appList = [];
    this.tecOwner = [];
    this.sloOwner = [];
    this.resetAppFilters();
  }
  focusGp() {
    if (this.groupName.length >= 60) {
      this.limitExhaust = true;
    } else this.limitExhaust = false;
  }
  focusdes() {
    if (this.Description.length >= 300) {
      this.limitExhaustDes = true;
    } else this.limitExhaustDes = false;
  }
  selectAlllobName(checkAllId, select: NgModel, values) {
    if (checkAllId) {
      const selectedLob = [];
      const selectedCategory = [];
      const selectedLifecycle = [];
      values.map(list => {
        selectedLob.push(list);
        list.category.forEach(value => {
          selectedCategory.push(value);
        });
        list.life_cycle.forEach(value => {
          selectedLifecycle.push(value);
        });
      });
      this.SelectedLob = this.removeDup(selectedLob);
      this.selectedLifecycle = this.removeDup(selectedLifecycle);
      this.selectedCatagory = this.removeDup(selectedCategory);
    } else {
      this.SelectedLob = [];
      this.selectedCatagory = [];
      this.selectedLifecycle = [];
      select.update.emit([]);
    }
  }
  getTechSloList() {
    this.sloOwner = [];
    this.applistService.getSloTechList('').subscribe((data: any) => {
      this.sloOwner = this.getUniqueListBy(data.sloList, 'name').sort(this.tcmUtilService.sortOnProperty('name'));
      this.tecOwner = this.getUniqueListBy(data.itownerList, 'name').sort(this.tcmUtilService.sortOnProperty('name'));
      this.techOwnerCache = this.tecOwner;
      this.sloOwnerCache = this.sloOwner;
    });
  }
  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()];
  }
  lobmulitiSelectAll;
  onCIOChanged() {
    const selectedCioIds = this.SelectedCIO.map(cio => {
      return cio.lob_id;
    });
    this.lobLists = [];
    const selectedloblist = [];
    this.SelectedLob = [];
    this.cioList.map(cio => {
      if (selectedCioIds.includes(cio.lob_id)) {
        cio.subLobnames.forEach(subLob => {
          this.lobLists.push(subLob);
          selectedloblist.push(subLob);
        });
      }
    });

    this.SelectedLob = this.removeDup(selectedloblist);
    this.allAppList = [];
    this.appList = [];
    this.applicationListConst.forEach(element => {
      if (selectedCioIds.includes(element['LOB_ID'])) {
        if (this.appList.length <= 500) this.appList.push(element);
        this.allAppList.push(element);
      }
    });
  }

  onLOBChanged() {
    const selectedLobIds = this.SelectedLob.map(lob => {
      return lob.subLob_id;
    });
    this.allAppList = [];
    this.appList = [];
    this.applicationListConst.forEach(element => {
      if (selectedLobIds.includes(element['SubLOB_ID'])) {
        if (this.appList.length <= 500) this.appList.push(element);
        this.allAppList.push(element);
      }
    });
  }

  removeDup(list) {
    return list.filter((item, pos) => {
      return list.indexOf(item) == pos;
    });
  }

  onTecOwnerChanged(technicalOwner) {
    this.loading = true;
    this.selctedTecOwner = technicalOwner.value;
    this.appList = [];
    this.allAppList = [];
    this.applicationListConst.forEach(app => {
      if (this.selctedTecOwner == app['Technical_Owner']) {
        this.appList.push(app);
      }
    });
    this.selectAll = true;
    this.appList = this.removeDup(this.appList);
    this.allAppList = this.appList;
    this.selectedApplicationName = [];
    this.selectedApplicationName = this.allAppList;
    this.selectedGlobalAppCode = [];
    this.selectedApplicationName.forEach(item => {
      this.selectedGlobalAppCode.push(item.ASK_GLOBAL_ID);
    });
    this.multiAppSelectAll = true;
    this.loading = false;
  }

  selecttechAppName() {
    const preselect = [];
    this.appList.forEach(item => {
      preselect.push(item.LONG_APP_NAME);
    });
    this.selectedApplicationName = preselect;
    this.selectAll = true;
    const preselectaskid = [];
    this.appList.forEach(item => {
      preselectaskid.push(item.ASK_GLOBAL_ID);
    });
    this.selectedGlobalAppCode = preselectaskid;
    this.selectallaskid = true;
  }

  onSloOwnerChanged(event) {
    this.loading = true;
    const selectedSLO = event.value;
    this.appList = [];
    this.allAppList = [];
    this.applicationListConst.forEach(app => {
      if (selectedSLO == app['SERVICE_LEVEL_OWNER']) {
        this.appList.push(app);
      }
    });
    this.appList = this.removeDup(this.appList);
    this.allAppList = this.appList;
    this.selectedApplicationName = this.appList;
    this.selectedGlobalAppCode = [];
    this.selectedApplicationName.forEach(item => {
      this.selectedGlobalAppCode.push(item.ASK_GLOBAL_ID);
    });
    this.selectAll = true;
    this.multiAppSelectAll = true;
    this.loading = false;
  }

  selectsloAppName() {
    const preselectapp = [];
    this.appList.forEach(item => {
      preselectapp.push(item.LONG_APP_NAME);
    });
    this.selectedApplicationName = preselectapp;
    const preselectaskid = [];
    this.appList.forEach(item => {
      preselectaskid.push(item.ASK_GLOBAL_ID);
    });
    this.selectedGlobalAppCode = preselectaskid;

    this.selectallaskid = true;
  }

  /**
   * method to reset to top when options is closed
   * @param opened param to tell if select options are opned
   * @param viewPort  reference of virtual scroll viewport which is to be reset
   */

  onAplicationValueChanged(applicationNames) {
    this.selectedGlobalAppCode = [];
    this.selectedApplicationName = [];
    applicationNames.value.forEach(item => {
      this.selectedGlobalAppCode.push(item.ASK_GLOBAL_ID);
      this.selectedApplicationName.push(item);
    });
    this.selectAll = true;
    this.multiAppSelectAll = true;
  }

  OnFilterApp() {
    if (this.selectedsloOwner) {
      return;
    } else if (this.selctedTecOwner) {
      return;
    }
    if (this.FAVC != '' && this.FAVC.length >= 3) {
      this.appList = [];
      let count = 0;
      for (let i = 0; i < this.allAppList.length && count < 500; i++) {
        if (this.allAppList.length > i) {
          Object.keys(this.allAppList[i]).some(key => {
            if (
              String(this.allAppList[i][key])
                .toLowerCase()
                .includes(this.FAVC.toLowerCase())
            ) {
              this.appList.push(this.allAppList[i]);
              count = count + 1;
            }
          });
        } else {
          break;
        }
      }
    } else {
      this.appList = this.applicationListConst.slice(0, 500);
    }
    return this.appList;
  }

  preupdateSelect() {
    this.selectedFilter =
      this.selectedApplicationName.length > 0
        ? this.details.applicationList.filter(x => this.selectedApplicationName.includes(x.LONG_APP_NAME))
        : [];
  }

  resetAppFilters() {
    this.multiAppSelectAll = false;
    this.selctedTecOwner = undefined;
    this.selectedsloOwner = undefined;
    this.selectedApplicationName = [];
    this.appList = this.applicationListConst.slice(0, 500);
    this.allAppList = this.applicationListConst;
    this.sloOwner = this.sloOwnerCache.slice(0, 500);
    this.tecOwner = this.techOwnerCache.slice(0, 500);
    this.selectedGlobalAppCode = undefined;
    this.SelectedLob = '';
    this.SelectedCIO = '';
    this.multiSelect = false;
    this.multiSelectAttr = '""';
    this.FSLO = '';
    this.FAVC = '';
    this.globalAskids = [];
    this.appids = [];
    this.searchStatus = false;
  }
  navigateHomePage() {
    this.route.navigate([{ outlets: { primary: 'maintenance/group' } }]);
  }

  selectAllAppName(checkAll, select: NgModel, values) {
    const selectObject = {};
    selectObject['value'] = [];
    this.selectAll = checkAll;
    if (checkAll) {
      select.update.emit(
        values.map(value => {
          selectObject['value'].push(value);
          return value;
        })
      );
      this.onAplicationValueChanged(selectObject);
      this.selectedApplicationName = this.allAppList;
    } else {
      select.update.emit([]);
      this.selectAll = false;
      this.selectedApplicationName = [];
    }
  }
  hidepopup() {
    const ele = this.container.nativeElement.querySelector('.hover_bkgr_fricc') as HTMLInputElement;
    ele.style.display = 'none';
  }
  showpopup() {
    window.open(environment.docUrl + 'user-guide/group-maintenance/');
  }

  appSelect() {
    if (this.appList.length == this.selectedApplicationName.length) this.selectAll = true;
    else this.selectAll = false;
  }

  uploadFileEvt(files: FileList) {
    if (files && files.length) {
      this.fileToUpload = files.item(0);
    } else {
      this.fileToUpload = null;
    }
  }

  resetValue() {
    this.CIO = ' ';
    this.ngmodel.reset(this.CIO);
  }
  
  resetInputForLob(){
    let blurData;
    if(this.CIO) {
      blurData = this.cioList.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.CIO.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.CIO = "";
    }
  }

  resetInputForSubLob(){
    let blurData;
    if(this.LOB) {
      blurData = this.lobLists.filter(x =>{
        return x.subLob_name.toString().toLowerCase().includes(this.LOB.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.LOB = "";
    }
  }

  resetInputForSloOwner(){
    let blurData;
    if(this.FSLO) {
      blurData = this.sloOwnerCache.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.FSLO.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.FSLO = "";
    }
  }

  resetInputForTechnicalOwner(){
    let blurData;
    if(this.Fowner) {
      blurData = this.techOwnerCache.filter(x =>{
        return x.name.toString().toLowerCase().includes(this.Fowner.toLowerCase());
      })
    }
    if (blurData && blurData.length < 1) {
      this.Fowner = "";
    }
  }

  resetInputValueForApplication(){
    let blurData;
    if(this.FAVC) {
      blurData = this.appList.filter(x =>{
        return (x.ASK_GLOBAL_ID.toString().toLowerCase().includes(this.FAVC.toLowerCase()) || x.LONG_APP_NAME.toString().toLowerCase().includes(this.FAVC.toLowerCase()));
      })
    }
    if (blurData && blurData.length < 1) {
      this.FAVC = "";
      this.appList = this.applicationListConst.slice(0, 500);
    }
  }

  checkWhetherCioIncludes(oneOfSelectedCio) {
    this.filteredCioList = [...this.cioList];
    let isInclude: boolean;
    this.filteredCioList.forEach(cioElem => {
      if (cioElem.name == oneOfSelectedCio.name) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

  
  checkWhetherSubLobIncludes(oneOfSelectedSubLob) {
    this.filteredSubLobList = [...this.lobLists];
    let isInclude: boolean;
    this.filteredSubLobList.forEach(subLobElem => {
      if (subLobElem.subLob_name.startsWith(this.LOB) && oneOfSelectedSubLob.subLob_name.startsWith(this.LOB)) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

  checkWhetherAppNameIncludes(oneOfSelectedAppName) {
    this.filteredAppNameList = [...this.appList];
    let isInclude: boolean;
    this.filteredAppNameList.forEach(appElem => {
      if (appElem.LONG_APP_NAME.startsWith(this.FAVC) && oneOfSelectedAppName.LONG_APP_NAME.startsWith(this.FAVC)) {
        isInclude = false;
      } else {
        isInclude = true;
      }
    });
    return isInclude;
  }

}
